import { defineComponent, computed, onMounted, ref } from 'vue';
import { RadioGroup } from '@hems/component';
export default defineComponent({
    name: 'ModeControl',
    components: {
        RadioGroup,
    },
    props: {
        data: {
            type: Object,
            default: null,
        },
        supportedModes: {
            type: Object,
            default: null,
        },
    },
    setup(props) {
        // @FIXME: 아래 컴포넌트 로직 리펙토링 이후 computed 요소 사용 재검토 필요
        const modeControlData = computed(() => props.data);
        const modeOptions = ref([]);
        onMounted(() => {
            if (props.supportedModes !== null) {
                const modes = props.supportedModes?.map((item) => {
                    return { text: item.charAt(0).toUpperCase() + item.slice(1), value: item };
                });
                modeOptions.value = modes;
            }
        });
        return {
            modeControlData,
            modeOptions,
        };
    },
});
